import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import Component from "./Node.vue";
import { createDefaultBlockForTipTap } from "~/stores/mail-block-editor/defaults";

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        html: {
            /**
             * Set a heading node
             * @param attributes The heading attributes
             * @example editor.commands.setHtml()
             */
            setHtml: () => ReturnType;
            /**
             * Toggle a heading node
             * @param attributes The heading attributes
             * @example editor.commands.toggleHtml()
             */
            toggleHtml: () => ReturnType;
        };
    }
}

const Html = Node.create({
    name: "html",
    group: "block",

    atom: true,
    defining: true,

    addAttributes() {
        return createDefaultBlockForTipTap("html");
    },

    parseHTML() {
        return [
            {
                tag: "custom-html",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ["div", mergeAttributes(HTMLAttributes)];
    },

    addNodeView() {
        return VueNodeViewRenderer(Component);
    },

    addCommands() {
        return {
            setHtml:
                () =>
                ({ commands }) => {
                    return commands.setNode(this.name);
                },
            toggleHtml:
                () =>
                ({ commands }) => {
                    const store = useMailStore();

                    return commands.toggleNode(
                        this.name,
                        "html",
                        useCloneDeep(store.currentBlock?.attrs ?? {}),
                    );
                },
        };
    },

    addKeyboardShortcuts() {
        return {
            "Mod-Alt-0": () => this.editor.commands.toggleHtml(),
        };
    },
});

export default Html;
